export const LOAD_INVENTORY = 'LOAD_INVENTORY';
export const CLEAR_INVENTORY = 'CLEAR_INVENTORY';
export const UPDATE_INVENTORY = 'UPDATE_INVENTORY';
export const REVERT_CLOSED_STATUS = 'REVERT_CLOSED_STATUS';
export const MARK_INVENTORY_CLOSED_STATUS = 'MARK_INVENTORY_CLOSED_STATUS';